import * as React from 'react'

function SubmitIcon(props) {
    return (
        <svg
            width="22px"
            height="22px"
            viewBox="0 0 1024 1024"
            className="icon"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M905.92 237.76a32 32 0 00-52.48 36.48A416 416 0 1196 512a418.56 418.56 0 01297.28-398.72 32 32 0 10-18.24-61.44A480 480 0 10992 512a477.12 477.12 0 00-86.08-274.24z"
                fill={`${props.fill || '#231815'}`}
            />
            <path
                d="M630.72 113.28a413.76 413.76 0 01137.28 72 32 32 0 0039.68-50.24 476.8 476.8 0 00-160-83.2 32 32 0 00-18.24 61.44zM489.28 86.72a36.8 36.8 0 0010.56 6.72 30.08 30.08 0 0024.32 0 37.12 37.12 0 0010.56-6.72A32 32 0 00544 64a33.6 33.6 0 00-9.28-22.72A32 32 0 00505.6 32a20.8 20.8 0 00-5.76 1.92 23.68 23.68 0 00-5.76 2.88l-4.8 3.84a32 32 0 00-6.72 10.56A32 32 0 00480 64a32 32 0 002.56 12.16 37.12 37.12 0 006.72 10.56zm-259.2 381.12a36.48 36.48 0 000 51.84L413.12 704a36.48 36.48 0 0051.84 0l328.96-330.56A36.48 36.48 0 00742.08 320L438.72 623.36l-156.8-155.52a36.8 36.8 0 00-51.84 0z"
                fill={`${props.fill || '#231815'}`}
            />
        </svg>
    )
}

export default SubmitIcon
